export const isDatePeriod = (period: string): boolean => {
    if (!period) return false;
    return /(?:^|\n)\d{2}-\d{2}-\d{2,4}(?:\n|$)/.test(period);
};

export const formatWeekHeader = (weekStartDate: string, weekIndex: number | null = null): string => {
    if (!weekStartDate) return weekStartDate;
    
    if (!weekStartDate)
        return weekStartDate;
    
    if (typeof weekIndex === 'number' && weekIndex >= 0) {
        const weekNumber = weekIndex + 1;
        return `${weekNumber}\n${weekStartDate}`;
    }
    
    return weekStartDate;
};